import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Policy.css';

const GrievanceRedressal = () => {
  return (
    <div className="App">
      <Header />
      <div className="page policy-page">
        <div className="container">
          <div className="policy-header">
            <h1>Grievance Redressal Policy</h1>
            <p className="policy-updated">Last Updated: January 2025</p>
          </div>

          <div className="policy-content">
            <section className="policy-section">
              <h2>1. Introduction</h2>
              <div className="policy-text">
                <p>
                  SLN BOOK WORLD is committed to providing excellent customer service and resolving 
                  any grievances or complaints in a fair, timely, and efficient manner. This Grievance 
                  Redressal Policy outlines the process for addressing customer concerns and complaints.
                </p>
                <p>
                  We value your feedback and are dedicated to ensuring your satisfaction with our 
                  products and services.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>2. Grievance Categories</h2>
              <div className="policy-text">
                <p>We address grievances related to:</p>
                <ul>
                  <li>Order processing and fulfillment issues</li>
                  <li>Product quality or defects</li>
                  <li>Delivery delays or problems</li>
                  <li>Billing and payment discrepancies</li>
                  <li>Payment gateway issues (HDFC Bank Smart Gateway)</li>
                  <li>Refund and cancellation issues</li>
                  <li>Customer service concerns</li>
                  <li>Website functionality problems</li>
                  <li>Privacy and data security concerns</li>
                  <li>Any other service-related issues</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>3. Grievance Submission Process</h2>
              <div className="policy-text">
                <h3>3.1 Step 1: Contact Customer Support</h3>
                <p>
                  First, please contact our customer support team through any of the following channels:
                </p>
                <ul>
                  <li><strong>Email:</strong> <a href="mailto:support@slnbooks.com">support@slnbooks.com</a></li>
                  <li><strong>Phone:</strong> <a href="tel:+919916832476">+91-9916832476</a>, <a href="tel:+919663622125">+91-9663622125</a></li>
                  <li><strong>Business Hours:</strong> Monday - Friday: 9:00 AM - 6:00 PM, Saturday: 10:00 AM - 4:00 PM</li>
                </ul>
                <p>
                  Our team will attempt to resolve your concern immediately or within 24-48 hours.
                </p>

                <h3>3.2 Step 2: Formal Grievance Submission</h3>
                <p>
                  If your concern is not resolved in Step 1, you may submit a formal grievance by:
                </p>
                <ul>
                  <li>Sending a detailed email to <a href="mailto:grievance@slnbooks.com">grievance@slnbooks.com</a></li>
                  <li>Including your order number (if applicable)</li>
                  <li>Providing a clear description of the issue</li>
                  <li>Attaching relevant documents, photos, or evidence</li>
                  <li>Stating your preferred resolution</li>
                </ul>

                <h3>3.3 Required Information</h3>
                <p>Please include the following information in your grievance:</p>
                <ul>
                  <li>Your full name and contact details</li>
                  <li>Order number (if applicable)</li>
                  <li>Date of the incident or transaction</li>
                  <li>Detailed description of the grievance</li>
                  <li>Supporting documents or evidence</li>
                  <li>Previous communication reference (if any)</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>4. Grievance Resolution Timeline</h2>
              <div className="policy-text">
                <h3>4.1 Initial Response</h3>
                <ul>
                  <li><strong>Level 1 (Customer Support):</strong> Within 24-48 hours</li>
                  <li><strong>Level 2 (Grievance Officer):</strong> Within 3-5 business days</li>
                  <li><strong>Level 3 (Management Review):</strong> Within 7-10 business days</li>
                </ul>

                <h3>4.2 Resolution Timeframe</h3>
                <ul>
                  <li>Simple grievances: 3-5 business days</li>
                  <li>Complex grievances: 7-14 business days</li>
                  <li>Grievances requiring investigation: Up to 21 business days</li>
                </ul>
                <p>
                  You will be kept informed of the progress throughout the resolution process.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>5. Grievance Escalation Levels</h2>
              <div className="policy-text">
                <h3>5.1 Level 1: Customer Support Team</h3>
                <p>
                  Initial contact point for all grievances. The team will attempt to resolve 
                  standard issues immediately or escalate to Level 2 if needed.
                </p>

                <h3>5.2 Level 2: Grievance Officer</h3>
                <p>
                  For unresolved issues or complex grievances, the matter is escalated to our 
                  designated Grievance Officer who will conduct a thorough review and provide 
                  a resolution.
                </p>

                <h3>5.3 Level 3: Management Review</h3>
                <p>
                  If you are not satisfied with Level 2 resolution, the grievance can be 
                  escalated to senior management for final review and decision.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>6. Grievance Officer Details</h2>
              <div className="policy-text">
                <p>
                  For escalation or formal grievances, please contact our Grievance Officer:
                </p>
                <ul>
                  <li><strong>Email:</strong> <a href="mailto:grievance@slnbooks.com">grievance@slnbooks.com</a></li>
                  <li><strong>Phone:</strong> <a href="tel:+919916832476">+91-9916832476</a></li>
                  <li><strong>Address:</strong> Ground Floor, 4 & 5, 6th Main Road, Dattatreya Nagar, Banashankari Stage 3, Bengaluru – 560085</li>
                  <li><strong>Response Time:</strong> Within 3-5 business days</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>7. Resolution Methods</h2>
              <div className="policy-text">
                <p>Depending on the nature of your grievance, resolution may include:</p>
                <ul>
                  <li>Replacement of defective or incorrect products</li>
                  <li>Full or partial refund as per our refund policy</li>
                  <li>Reshipment of lost or damaged orders</li>
                  <li>Compensation for inconvenience (at our discretion)</li>
                  <li>Service improvement measures</li>
                  <li>Apology and explanation</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>8. External Dispute Resolution</h2>
              <div className="policy-text">
                <h3>8.1 Consumer Forums</h3>
                <p>
                  If you are not satisfied with our internal grievance resolution, you have the 
                  right to approach the appropriate consumer forum or court as per the Consumer 
                  Protection Act, 2019.
                </p>

                <h3>8.2 Alternative Dispute Resolution</h3>
                <p>
                  We are open to resolving disputes through mediation or arbitration if mutually 
                  agreed upon by both parties.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>9. Confidentiality</h2>
              <div className="policy-text">
                <p>
                  All grievances and related information are treated with strict confidentiality. 
                  We will only share information with authorized personnel involved in the 
                  resolution process and as required by law.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>10. Feedback and Improvement</h2>
              <div className="policy-text">
                <p>
                  We use grievance data to identify areas for improvement in our products and 
                  services. Your feedback helps us serve you better and enhance customer satisfaction.
                </p>
                <p>
                  We may contact you after resolution to seek feedback on the grievance handling 
                  process.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>11. Contact Information</h2>
              <div className="policy-text">
                <p>
                  For any grievances or complaints, please contact us:
                </p>
                <ul>
                  <li><strong>Customer Support Email:</strong> <a href="mailto:support@slnbooks.com">support@slnbooks.com</a></li>
                  <li><strong>Grievance Officer Email:</strong> <a href="mailto:grievance@slnbooks.com">grievance@slnbooks.com</a></li>
                  <li><strong>Phone:</strong> <a href="tel:+919916832476">+91-9916832476</a>, <a href="tel:+919663622125">+91-9663622125</a></li>
                  <li><strong>Address:</strong> Ground Floor, 4 & 5, 6th Main Road, Dattatreya Nagar, Banashankari Stage 3, Bengaluru – 560085</li>
                  <li><strong>Business Hours:</strong> Monday - Friday: 9:00 AM - 6:00 PM, Saturday: 10:00 AM - 4:00 PM</li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GrievanceRedressal;

